import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            最新影视预告片、幕后花絮与独家采访，先睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video w-full overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-1 text-[10px] font-medium bg-black/60 text-background-50 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{item.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}